import request from '@/utils/request'
export function update(data) {
  return request({
    url: '/nav/theme/config/',
    method: 'put',
    data
  })
}
